export const roleStyles = {
  system: {
    label: "System",
    chip: "bg-[#d8b769]/15 text-[#f6d982] border-[#d8b769]/35",
    bubble: "bg-[#d8b769]/10 border-[#d8b769]/25 text-[#fff8df]",
    align: "items-center",
    max: "max-w-[92%]",
  },
  driver: {
    label: "Driver",
    chip: "bg-emerald-400/12 text-emerald-200 border-emerald-300/25",
    bubble: "bg-emerald-400/10 border-emerald-300/20 text-emerald-50",
    align: "items-start",
    max: "max-w-[82%]",
  },
  admin: {
    label: "Admin",
    chip: "bg-[#d8b769]/18 text-[#f6d982] border-[#d8b769]/40",
    bubble: "bg-[#d8b769]/16 border-[#d8b769]/35 text-[#fff8df]",
    align: "items-end",
    max: "max-w-[82%]",
  },
  passenger: {
    label: "Passenger",
    chip: "bg-white/10 text-white/85 border-white/15",
    bubble: "bg-white/[0.075] border-white/12 text-white",
    align: "items-start",
    max: "max-w-[82%]",
  },
};

export function getRoleMeta(role, labels = {}) {
  const meta = roleStyles[role] || roleStyles.system;
  return {
    ...meta,
    label: labels[role] || meta.label,
  };
}

export function normalizeSenderRole(message = {}, order = {}) {
  const rawRole = (message.sender_role || "").trim().toLowerCase();
  const senderId = (message.sender_id || "").trim();
  const senderName = (message.sender_name || "").trim().toLowerCase();
  const assignedDriverId = (order.assigned_driver_id || "").trim();

  if (assignedDriverId && senderId && senderId === assignedDriverId) {
    return "driver";
  }
  if (senderId === "passenger-token") {
    return "passenger";
  }
  if (rawRole === "admin" || senderName.includes("admin") || senderName.includes("管理员")) {
    return "admin";
  }
  if (rawRole === "driver" || senderName.includes("driver") || senderName.includes("司机")) {
    return "driver";
  }
  if (rawRole === "passenger") {
    return "passenger";
  }
  if (rawRole === "system") {
    return "system";
  }
  return "passenger";
}

export function getDisplayName(message, order = {}, labels = {}) {
  const normalizedRole = normalizeSenderRole(message, order);
  const meta = getRoleMeta(normalizedRole, labels);
  const name = (message.sender_name || "").trim();
  if (!name || (name === "Passenger" && normalizedRole !== "passenger")) {
    return meta.label;
  }
  return name;
}
